import http from './http';

const networkingCheckTask = args => async () => {
  const { onNetworkStateChange, onTokenError, getIsLoggedIn } = args;
  let isOnline = true;
  const isLoggedIn = getIsLoggedIn();

  try {
    await Promise.race([
      fetch('https://google.com', { mode: 'no-cors' }),
      new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 10000)),
    ]);
  } catch (e) {
    // is offline
    isOnline = false;
  }

  onNetworkStateChange(isOnline);

  if (isOnline && isLoggedIn) {
    try {
      await http.get('/api/client/getaddress');
    } catch (e) {
      // have no access to resource so log out
      onTokenError();
    }
  }

  setTimeout(networkingCheckTask(args), 5000);
};

export default { networkingCheckTask };
